

// Global state for alerts
let alertContainer = null;
let alertId = 0;

// Initialize the alert container
const initializeAlertContainer = () => {
  if (!alertContainer) {
    alertContainer = document.createElement('div');
    alertContainer.id = 'alert-container';
    alertContainer.className = 'fixed top-4 right-4 z-50 pointer-events-none flex flex-col gap-2 max-w-xs w-full';
    document.body.appendChild(alertContainer);
  }
  return alertContainer;
};

// Create alert element using Tailwind CSS classes
const createAlertElement = (message, type) => {
  const container = initializeAlertContainer();
  const alertDiv = document.createElement('div');
  const currentId = ++alertId;
  
  alertDiv.id = `alert-${currentId}`;
  
  // Clean modern design with subtle effects
  const baseClasses = 'transform transition-all duration-300 ease-out translate-x-full opacity-0 pointer-events-auto border shadow-lg rounded-lg p-3 relative';
  
  const alertClasses = type === 'success' 
    ? 'bg-white border-green-200 shadow-green-100'
    : 'bg-white border-red-200 shadow-red-100';
  
  alertDiv.className = `${baseClasses} ${alertClasses}`;
  
  // Simple, clean icons
  const successIcon = `
    <div class="flex-shrink-0 w-5 h-5 bg-green-100 rounded-full flex items-center justify-center">
      <svg class="w-3 h-3 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
      </svg>
    </div>
  `;
  
  const errorIcon = `
    <div class="flex-shrink-0 w-5 h-5 bg-red-100 rounded-full flex items-center justify-center">
      <svg class="w-3 h-3 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </div>
  `;
  
  // Clean structure with compact spacing
  alertDiv.innerHTML = `
    <div class="flex items-start gap-3">
      ${type === 'success' ? successIcon : errorIcon}
      <div class="flex-1 min-w-0">
        <p class="text-sm font-medium ${type === 'success' ? 'text-gray-800' : 'text-gray-800'} leading-tight">${message}</p>
      </div>
    </div>
  `;

  container.appendChild(alertDiv);

  // Simple slide-in animation
  setTimeout(() => {
    alertDiv.className = alertDiv.className.replace('translate-x-full opacity-0', 'translate-x-0 opacity-100');
  }, 10);

  // Auto remove after 5 seconds
  setTimeout(() => {
    alertDiv.className = alertDiv.className.replace('translate-x-0 opacity-100', 'translate-x-full opacity-0');
    setTimeout(() => {
      if (alertDiv.parentNode) {
        alertDiv.parentNode.removeChild(alertDiv);
      }
    }, 300);
  }, 3000);

  return alertDiv;
};

// Export the alert functions
export const SuccessAlert = (message) => {
  createAlertElement(message, 'success');
};

export const ErrorAlert = (message) => {
  createAlertElement(message, 'error');
};